import React from 'react'
import {
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Popover,
  FormControl,
  RadioGroup,
  Radio,
  colors,
  FormControlLabel,
} from "@mui/material";
import { useWorkspace } from '../../../../contexts/WorkspaceContext';
import Info from "../../../../assets/info.png"

const PeopleAndFaces = () => {

  const {veoVideoPeopleAndFaces, setVeoVideoPeopleAndFaces} = useWorkspace()

  // Function to handle radio value change
const handlePeopleAndFacesChange = (event) => {
  setVeoVideoPeopleAndFaces(event.target.value);
};

  return (
    <div>
      <div>
      <Box sx={{ padding: "20px 20px 0px 0px" }}>
        <Box sx={{ display: "flex", flexDirection: "row", columnGap: "12px", marginBottom:"20px", color:"#ffffff" }}>
          <Typography>Select people and faces generation preferences</Typography>
        </Box>
        <Box sx={{marginBottom:"40px"}}>
          <FormControl>
            <RadioGroup value={veoVideoPeopleAndFaces} onChange={handlePeopleAndFacesChange} name="radio-buttons-group">
              <FormControlLabel sx={{fontSize:"14px", color:"#ffffff"}}
                value="dont_allow"
                control={<Radio sx={{color: '#373E6D',  '&.Mui-checked': {  color: 'white', },'& .MuiSvgIcon-root': {backgroundColor: '#373E6D',borderRadius: '50%', }, '&:hover':{backgroundColor: 'transparent',}}}/>}
                label="Don't allow the inclusion of people or faces"
              />
              <FormControlLabel sx={{fontSize:"14px", color:"#ffffff"}}
                value="allow_adult"
                control={<Radio sx={{color: '#373E6D',  '&.Mui-checked': {  color: 'white', },'& .MuiSvgIcon-root': {backgroundColor: '#373E6D',borderRadius: '50%','&:hover':{backgroundColor: 'transparent',} },}}/>}
                label="Allow adults only - Generate videos that include adults but not children"
              />
              <FormControlLabel sx={{fontSize:"14px", color:"#ffffff"}}
                value="allow_all"
                control={<Radio  sx={{color: '#373E6D',  '&.Mui-checked': {  color: 'white', },'& .MuiSvgIcon-root': {backgroundColor: '#373E6D',borderRadius: '50%','&:hover':{backgroundColor: 'transparent',} },}}/>}
                label="Allow all - Generate videos that include adults and children"
              />
            </RadioGroup>
          </FormControl>
        </Box>
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 400,
                textAlign: "left",
                gap: "8px",
                color: "rgba(255, 255, 255, 0.80)",
              }}>
                <Box>
                  <img src={Info} alt="info" height={"16px"} width={"16px"}/>
                </Box>

                <Box sx={{

                }}>
                  <Typography sx={{
                    fontFamily : 'Inter',
                    fontSize : '12px',
                    fontWeight : 400,
                    fontStyle:"normal",
                    lineHeight : '20px',
                    letterSpacing : '0.10000000149011612px',
                    textAlign : 'left', 
                    color: "rgba(255, 255, 255, 0.80)",
                  }}>
                  {`If you upload images while generating voice-over videos, ‘Allow all’ if selected will change to ‘Adults only’`}
                  </Typography>

                </Box>
              </Box>
      </Box>
    </div>
    </div>
  )
}

export default PeopleAndFaces